<template>
  <pf-page-section no-body-wrapper>
    <pf-title h="2" v-if="title">{{ title }}</pf-title>

    <pf-data-list>
      <pf-data-list-item v-for="row of documents" :key="row.name">
        <pf-data-list-cell>
          <file-pdf-icon />
          {{ ' ' }}
          <span :title="row.name">{{ row.name }}</span>
        </pf-data-list-cell>

        <pf-data-list-cell>
          <p>{{ row.description }}</p>
        </pf-data-list-cell>

        <pf-data-list-action>
          <pf-button v-if="row.link" variant="secondary" target="_blank" :href="row.link">
            {{ label }}
          </pf-button>
          <pf-button v-else-if="row.contract" variant="secondary" @click="showContract = row.contract">
            {{ _t('Leggi') }}
          </pf-button>
        </pf-data-list-action>
      </pf-data-list-item>
    </pf-data-list>
  </pf-page-section>

  <pf-modal :open="!!showContract" @update:open="$event ? undefined : (showContract = undefined)" variant="medium">
    <template v-if="contract">
      <h2>{{ contract.titolo }}</h2>
      <iframe class="terms" referrerpolicy="no-referrer" sandbox="" :srcdoc="contract.testo" width="100%" style="min-height: 600px" />
    </template>

    <pf-empty-state v-else>
      <pf-empty-state-header :title="$t('Caricamento termini e condizioni')" heading-level="h4">
        <template #icon>
          <pf-empty-state-icon>
            <pf-spinner />
          </pf-empty-state-icon>
        </template>
      </pf-empty-state-header>
    </pf-empty-state>

    <template #footer>
      <pf-button @click="showContract = undefined">
        {{ _t('Chiudi') }}
      </pf-button>
    </template>
  </pf-modal>
</template>

<script lang="ts" setup>
import { type Ref, ref } from 'vue';
import { $t as _t } from '@/i18n';
import { ContractResource } from '@/resources';
import { asyncComputed } from '@common/asyncComputed';
import FilePdfIcon from '@vue-patternfly/icons/file-pdf-icon';

export type Document = {
  name: string;
  description: string;
  link?: string;
  contract?: 'cliente' | 'rivenditore';
};

const showContract: Ref<'cliente' | 'rivenditore' | undefined> = ref();

defineProps<{
  title: string;
  label: string;
  documents: Document[];
}>();

const { result: contract } = asyncComputed(async () => {
  if (showContract.value !== undefined) {
    const contract = await new ContractResource().get(showContract.value);
    contract.testo = `<html><head><style>
body {
  zoom: 80%;
  margin: 10px;
}

p:first-child {
  margin-top: 0;
}

p:last-child {
  margin-bottom: 0;
}
</style></head>
<body>${contract.testo}</body></html>`;
    return contract;
  }
});
</script>
